"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MultiSelect;
var _react = _interopRequireWildcard(require("react"));
require("./styles.scss");
var _IconTooltip = _interopRequireDefault(require("../IconTooltip"));
var _material = require("@mui/material");
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
var _PillList = _interopRequireDefault(require("../PillList"));
function MultiSelect(props) {
  const {
    className,
    disabled,
    fullWidth,
    helperText,
    errorText,
    id,
    label,
    missingValuePlaceholder,
    onAdd,
    onRemove,
    onPillClick,
    options,
    optionsVisible,
    pillListClassName,
    placeHolder,
    selectedOptions,
    sx,
    tooltipTitle,
    valueRenderer
  } = props;
  const [openedOptions, setOpenedOptions] = (0, _react.useState)(false);
  const toggleOptions = () => {
    setOpenedOptions(isOpen => !isOpen && !disabled);
    if (props.onFocus) {
      props.onFocus();
    }
  };
  (0, _react.useEffect)(() => {
    if (optionsVisible !== undefined) {
      setOpenedOptions(optionsVisible);
    }
  }, [optionsVisible]);
  const onBlurHandler = event => {
    // In Chrome > 126, the onBlur event will fire even if you are clicking _within_ the focused element
    // If this is the case, we do not actually want to blur
    if (event.currentTarget.contains(event.relatedTarget)) {
      return;
    }
    setOpenedOptions(false);
    if (props.onBlur) {
      props.onBlur();
    }
  };
  const unselectedOptions = Array.from(options.keys()).filter(key => !selectedOptions.includes(key));
  const valuesPillData = selectedOptions.map(item => {
    const value = options.get(item);
    return {
      id: item,
      value: value ? valueRenderer(value) : missingValuePlaceholder || ''
    };
  }).filter(data => data.value);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "multi-select ".concat(className),
    sx: sx
  }, label && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: "multi-select__label"
  }, label, " ", tooltipTitle && /*#__PURE__*/_react.default.createElement(_IconTooltip.default, {
    title: tooltipTitle
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "multi-select__container ".concat(fullWidth ? 'multi-select__container--fullWidth' : ''),
    onBlur: onBlurHandler,
    tabIndex: 0
  }, /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    className: "multi-select__values".concat(disabled ? '--disabled' : '').concat(openedOptions ? ' open' : '').concat(errorText ? ' error' : ''),
    onClick: toggleOptions
  }, selectedOptions.length > 0 ? /*#__PURE__*/_react.default.createElement(_PillList.default, {
    data: valuesPillData,
    onRemove: onRemove,
    onClick: onPillClick,
    className: pillListClassName
  }) : /*#__PURE__*/_react.default.createElement("p", {
    className: "multi-select__placeholder-text"
  }, placeHolder), /*#__PURE__*/_react.default.createElement("div", {
    className: 'multi-select__values__icon-button',
    "aria-label": "show-options"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: openedOptions ? 'chevronUp' : 'chevronDown',
    className: "multi-select__values__icon-right".concat(disabled ? '--disabled' : '')
  }))), options && unselectedOptions.length > 0 && openedOptions && /*#__PURE__*/_react.default.createElement("div", {
    className: "multi-select__options-container"
  }, /*#__PURE__*/_react.default.createElement("ul", {
    className: 'multi-select__options'
  }, unselectedOptions.map((optionKey, index) => {
    const optionValue = options.get(optionKey);
    return /*#__PURE__*/_react.default.createElement("li", {
      key: index,
      className: "select-value",
      onClick: () => onAdd(optionKey)
    }, optionValue ? valueRenderer(optionValue) : missingValuePlaceholder || '');
  })))), helperText && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: "multi-select__help-text"
  }, helperText), errorText && /*#__PURE__*/_react.default.createElement("div", {
    className: "multi-select__error"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "error",
    className: "multi-select__error-icon"
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: "multi-select__error-text"
  }, errorText)));
}